(function () {
  var config = window.KartologyaMenuGate || {};
  if (!config.enabled) return;

  var href = config.href || '/pages/kartologya-test';
  var label = config.label || 'Kartologya';
  var marker = 'data-kartologya-menu-link';

  function createDesktopItem() {
    var li = document.createElement('li');
    li.setAttribute(marker, 'true');
    var a = document.createElement('a');
    a.href = href;
    a.className = 'header__menu-item list-menu__item link link--text focus-inset';
    a.textContent = label;
    li.appendChild(a);
    return li;
  }

  function createDrawerItem() {
    var li = document.createElement('li');
    li.setAttribute(marker, 'true');
    var a = document.createElement('a');
    a.href = href;
    a.className = 'menu-drawer__menu-item list-menu__item link link--text focus-inset';
    a.textContent = label;
    li.appendChild(a);
    return li;
  }

  function appendIfMissing(list, factory) {
    if (!list || list.querySelector('[' + marker + ']')) return;
    list.appendChild(factory());
  }

  function inject() {
    [
      '.header__inline-menu .list-menu--inline',
      '.header__inline-menu .list-menu',
      'header nav ul',
    ].forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (list) {
        appendIfMissing(list, createDesktopItem);
      });
    });

    [
      '#menu-drawer .menu-drawer__menu',
      '.menu-drawer__navigation .menu-drawer__menu',
      '.menu-drawer__navigation ul',
    ].forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (list) {
        appendIfMissing(list, createDrawerItem);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
})();
